// extracted by mini-css-extract-plugin
export var shape = "styles-module--shape--14d97";
export var square = "styles-module--square--be357";
export var triangle = "styles-module--triangle--3d25b";
export var triangleBottom = "styles-module--triangleBottom--a9947";
export var triangleTop = "styles-module--triangleTop--94c4f";